import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_FULL } from '@/lib/gridElements/size';

import MediaLifeSpan from '@/components/composite/Charts/composed/MediaLifeSpan';

export const postLifespanConfig = {
    margin: { left: -30, bottom: 15 },
    minWidth: 650,
    name: {
        time: 'time',
        value: 'current_post',
        previous_value: 'previous_post'
    },
    id: 'post_lifespan',
    timeFormatter: (time) => time.replace(':', 'h'),
    valueFormat: classicFormat,
    color: {
        value: 'red',
        previous_value: 'gray'
    },
    tooltip: 'chart.twitter.tooltip_post_lifespan',
    size: SIZE_FULL,
    type: 'chart',
    defaultFilter: 'like_count',
    filters: {
        like_count: {
            title: 'chart.twitter.post_lifespan_likes',
            menu: 'chart.twitter.post_lifespan_show_likes'
        },
        reply_count: {
            title: 'chart.twitter.post_lifespan_replies',
            menu: 'chart.twitter.post_lifespan_show_replies'
        },
        retweet_count: {
            title: 'chart.twitter.post_lifespan_retweets',
            menu: 'chart.twitter.post_lifespan_show_retweets'
        }
    },
    tooltipTranslation: {
        filtersToken: {
            like_count: 'chart.twitter.post_lifespan_tooltip_chart_likes',
            reply_count: 'chart.twitter.post_lifespan_tooltip_chart_replies',
            retweet_count: 'chart.twitter.post_lifespan_tooltip_chart_reposts'
        },
        values: ['time', 'value', 'previous_value']
    },
    element: MediaLifeSpan
};
